import Head from "next/head";
import { SessionCompanionLanding } from "components/organisms/SessionCompanionLanding";
export default function SessionCompanionPage() {
  return <>
            <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
                <title>
                    CharGen: Session Companion - AI-Assisted RPG Session
                    Companion
                </title>
                <link rel="canonical" href="https://char-gen.com/session-companion" />
                <meta name="description" content="Record and transcribe your RPG sessions in real-time with the CharGen Session Companion. Generate AI Images in real-time for your campaign." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:url" key="og:url" content="https://char-gen.com/session-companion" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:description" key="og:description" content="Record and transcribe your RPG sessions in real-time with the CharGen Session Companion. Generate AI Images in real-time for your campaign." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
            </Head>
            <SessionCompanionLanding data-sentry-element="SessionCompanionLanding" data-sentry-source-file="index.tsx" />
        </>;
}